(()=>{
  document.querySelectorAll('[data-ux-search-form]').forEach(form=>form.addEventListener('submit',event=>{
    const query=form.querySelector('[name="q"]').value.trim();
    const words=query.match(/[\p{L}\p{N}]+/gu)||[];
    if(!words.length)return;
    event.preventDefault();
    const url=new URL(form.action,location.origin);
    url.search=new URLSearchParams(new FormData(form)).toString();
    url.searchParams.set('q',words.map(word=>'title:'+word).join(' AND '));
    location.assign(url.href);
  }));
  const root=document.querySelector('[data-ux-browse]');
  if(root){
    const facets=root.querySelector('[data-ux-facets]');
    const desktop=matchMedia('(min-width:900px)');
    const setFacetState=()=>{facets.open=desktop.matches;};
    setFacetState();desktop.addEventListener('change',setFacetState);
  }
})();
